import React from 'react';
import './Info.css';
import shortLogo from 'images/ENData Logo.png'

type InfoPorps = {
  title: string,
  dcp: string,
}

const Info: React.FC<InfoPorps> = ({ title, dcp, ...props }) => {
  return (
    <div {...props} className="px-5">
      <div className="grid grid-cols-3">
        <div className="col-span-3 text-center">
          <div className="text-4xl font-bold pt-3">{title}</div>
        </div>
        <div className="col-start-2 flex justify-center">
          <img src={shortLogo} alt='' className="col-start-2 h-5 w-8 my-1 "/>
        </div>
        <div className="col-span-3">
          <p className="flex justify-center text-center text-gray-600">
            { dcp }
          </p>
        </div>
      </div>
    </div>
  )
}

export default Info;